import axios from 'axios';
import util from '../utils/utils';

const USERID_EXCEPTS_URL = ['/get_full_policy','/policy_timeline&mind_map','/get_policy_jiedu','v1/chat/completions'];
const ABROAD_EXCEPTS_URL = ['kdi','development_research_center','brookings','google'];

const containsAny = (str, array)=>{
  return array.some(element => str.includes(element));
}

const Axios = axios.create({
  baseURL: process.env.REACT_APP_DOMAIN_API
});
Axios.defaults.timeout = 60000;

// 为收藏相关接口设置更短的超时时间
const COLLECTION_URLS = ['/policy/save_content', '/policy/delete_saved_content', '/policy/get_saved_content', '/policy/get_saved_fold_list'];
const isCollectionRequest = (url) => COLLECTION_URLS.some(collectionUrl => url.includes(collectionUrl));

Axios.interceptors.request.use(
  config => { 
    // 为收藏相关接口设置更短的超时时间（50秒）
    if (isCollectionRequest(config.url)) {
      config.timeout = 50000;
    }
    
    if (containsAny(config.url,ABROAD_EXCEPTS_URL)) {
      config.baseURL = process.env.REACT_APP_TANK_API
    }
    if (config.url.includes('weixin')) {
      config.baseURL = process.env.REACT_APP_WEIXIN_API
    }
    
    // 添加Authorization header（如果环境变量中有配置）
    if (process.env.REACT_APP_AUTHORIZATION_TOKEN) {
      config.headers = {
        ...config.headers,
        'Authorization': `Bearer ${process.env.REACT_APP_AUTHORIZATION_TOKEN}`
      };
    }
    
    if(config.method === 'get' && !containsAny(config.url,USERID_EXCEPTS_URL)) {
      config.params = {
          ...config.params,
          user_id: util.getUserId()
      }
    } else if(!containsAny(config.url,USERID_EXCEPTS_URL)){
        config.data = {
            ...config.data,
            user_id: util.getUserId()
        }
    }
    
    // 检查是否需要设置 responseType 为 blob
    if (config.responseType === 'blob') {
      config.responseType = 'blob';
    }
    
    return config;
  }, 
  error => { 
    return Promise.reject(error)
  })
// 响应拦截器
Axios.interceptors.response.use(
  response => {
    // if (response && response.status === 200) {
      // console.log(response)
      return response
    // }
    // else { 
    //   window.alert('请稍后重试')
    // }
  },
  error =>{
    // window.alert('出错了，请稍后重试')
    return error
  } 
)
export default Axios
  